import mpProductsApi from "@/api/mpProducts";


const state = {
    all: [],
    mpProduct: {},
    missingProducts: []
};

const getters = {
    mpProduct: state => {
        return state.mpProduct;
    },
    missingProducts: state => {
        return state.missingProducts;
    },
    mpProductCategories: state => {
        return state.all.filter(n => n.onSale).map(m => {
            return {
                name: m.mpSku + " - " + (m.product 
                    ? m.product.name + " (" + m.product.sku + ")"
                    : "Bilinmeyen Ürün"),
                id: m.id
            };
        });
    }
};


const actions = {
    getAllMpProducts: async context => {
        let d = (await mpProductsApi.getMpProducts()).data;
        context.commit("getMpProducts", d);
    },
    searchMpProduct: async (context, mpProduct) => {
        let d = (await mpProductsApi.searchMpProduct(mpProduct)).data;
        context.commit("getMpProducts", d);
        return d;
    },
    getMpProduct: async (context, id) => {
        let d = (await mpProductsApi.getMpProduct(id)).data;
        context.commit("getMpProduct", d);
        return d;
    },
    postMpProduct: async (context, mpProduct) => {
        const result = (await mpProductsApi.postMpProduct(mpProduct)).data;
        context.commit("postMpProduct", result);
        return result;
    },
    putMpProduct: async (context, mpProduct) => {
        const result = (await mpProductsApi.putMpProduct(mpProduct)).data;
        context.commit("putMpProduct", result);
        return result;
    },
    deleteMpProduct: async (context, mpProduct) => {
        await mpProductsApi.deleteMpProduct(mpProduct);
        context.commit("deleteMpProduct", mpProduct);
    },
    
    // Özel actions
    getMissingProducts: async context => {
        let d = (await mpProductsApi.getMissingProducts()).data;
        context.commit("getMissingProducts", d);
        return d;
    },
    getMpProductByProduct: async (context, productId) => {
        let d = (await mpProductsApi.getMpProductByProduct(productId)).data;
        return d;
    },
    syncFromMainProducts: async (context, productIds = null) => {
        await mpProductsApi.syncFromMainProducts(productIds);
        // Sync işleminden sonra listeyi yenile
        await context.dispatch('getAllMpProducts');
        return true;
    },
    getMpProductsByMarketplace: async context => {
        let d = (await mpProductsApi.getMpProductsByMarketplace()).data;
        context.commit("getMpProducts", d);
        return d;
    }
};

const mutations = {
    getMpProducts(state, mpProducts) {
        state.all = mpProducts;
    },
    getMpProduct(state, mpProduct) {
        state.mpProduct = null;
        state.mpProduct = Object.assign({}, state.mpProduct, mpProduct);
    },
    postMpProduct(state, mpProduct) {
        state.all.push(mpProduct);
        state.mpProduct = null;
        state.mpProduct = Object.assign({}, state.mpProduct, mpProduct);
    },
    putMpProduct(state, mpProduct) {
        const index = state.all.findIndex(item => item.id === mpProduct.id);
        if (index !== -1) {
            state.all.splice(index, 1, mpProduct);
        }
        state.mpProduct = null;
        state.mpProduct = Object.assign({}, state.mpProduct, mpProduct);
    },
    deleteMpProduct(state, mpProduct) {
        state.all.splice(state.all.indexOf(mpProduct), 1);
    },
    getMissingProducts(state, products) {
        state.missingProducts = products;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

